module.exports = __webpack_public_path__ + "static/media/facebook.14bf1fe2.svg";